module.exports = __webpack_public_path__ + "static/media/pattern-3.879bac5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/patterns/pattern-3.png
// module id = 4918
// module chunks = 15